import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";

class ExistCommonCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }

  render() {
    const { pageSize, totalRecords, currentPage, arraylist } = this.props;

    return (
      <div className="" style={{ paddingTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <Paginator
            className="mb-3"
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
            <div
              className="card"
              style={{ overflow: "hidden", position: "relative" }}
            >
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  No Items
                </h6>
              </div>
            </div>
          )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, DeleteKeyword } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative" }}>
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-md-11 col-sm-10 col-10 col-m-auto"}>
                    <div className="row px-3">
                      <div className={showSidePane ? "col-sm-12" : "col-sm-12"}>
                        <span>
                          <strong>Keyword :{" "} </strong>
                          <span className="italicFont">
                            {item?.description}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={"col-sm-2 col-md-1 col-m-auto col-2"}>
                    <div className={showSidePane ? "text-center" : "text-center"}>
                      <i
                        className="fa fa-trash-o fa-2x click p-2"
                        aria-hidden="true"
                        style={{ color: "#1E3A8A" }}
                        onClick={() => DeleteKeyword(item)}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
 
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ExistCommonCard)
);
